import type { Account } from '@interfaces/account';
import { ApplyForGovFunds } from '@interfaces/account';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box } from '@ovComponents/1-primative/box/box';
import { Icon } from '@ovComponents/1-primative/icon/icon';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { Card, CardContent } from '@ovComponents/2-component/card/card';
import { IconButton } from '@ovComponents/2-component/iconButton/iconButton';
import { GoalLinkingReview } from '@ovComponents/4-module/workflowCompletion/subSteps/account/goalLinking';
import React from 'react';
import { useTranslation } from 'react-i18next';

type RespAdultReviewItemProps = {
  account: Account;
  onDeleteAccount: (account?: Account) => void;
};
export const RespAdultReviewItem = ({
  account,
  onDeleteAccount,
}: RespAdultReviewItemProps) => {
  const { t } = useTranslation(['workflowCompletions', 'affiliationTypes']);
  return (
    <Card variant='outlined' sx={{ mb: 2 }}>
      <CardContent>
        <Box
          sx={{ pl: 0.9 }}
          display='flex'
          flexDirection='row'
          alignItems='center'
          justifyContent='space-between'
        >
          <Typography variant='bodyLarge' weight='bold'>
            {t('workflowCompletions:accountReviewPanel.respAdult')}
          </Typography>
          {account.id ? undefined : (
            <IconButton onClick={() => onDeleteAccount()}>
              <Icon icon={CloseRoundedIcon} size='small' />
            </IconButton>
          )}
        </Box>
        <Box
          sx={{ mt: 2, mb: 1, px: 1 }}
          display='flex'
          flexDirection='row'
          justifyContent='space-between'
        >
          <Typography variant='labelLarge' weight='bold'>
            {t(
              'workflowCompletions:accountReviewPanel.basicCanadaEducationSavingsGrant',
            )}
          </Typography>
          <Typography variant='bodyMedium'>
            {account.applyForGovFunds?.includes(ApplyForGovFunds.BASIC_CESG)
              ? 'Yes'
              : 'No'}
          </Typography>
        </Box>
        <Box
          sx={{ mt: 1, mb: 1, px: 1 }}
          display='flex'
          flexDirection='row'
          justifyContent='space-between'
        >
          <Typography variant='labelLarge' weight='bold'>
            {t('workflowCompletions:accountReviewPanel.canadaLearningBond')}
          </Typography>
          <Typography variant='bodyMedium'>
            {account.applyForGovFunds?.includes(ApplyForGovFunds.CLB)
              ? 'Yes'
              : 'No'}
          </Typography>
        </Box>
        <Box
          sx={{ mt: 1, px: 1 }}
          display='flex'
          flexDirection='row'
          justifyContent='space-between'
        >
          <GoalLinkingReview account={account} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default RespAdultReviewItem;
